var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"booksListZh"}},[_c('zh-search-class',{ref:"childTwo",on:{"Search":_vm.Search}}),_c('div',{staticClass:"booksListZh"},[_c('zh-lay-list-books',{ref:"child",on:{"pushTele":_vm.pushTele}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }